import _ from 'lodash';
/**
 * スライド検索 タイプ: スライドごと（まとめて表示）
 * @type {number}
 */
export const CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_SLIDE = 'slide';
/**
 * スライド検索 タイプ: ページごと
 * @type {number}
 */
export const CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE = 'page';
/**
 * スライド種別 4:縦タイプ
 * @type {number}
 */
export const CONSULTANT_SEARCH_SLIDE_TYPE_IMAGE_VERTICAL = 4;
/**
 * スライド種別 5:横タイプ
 * @type {number}
 */
export const CONSULTANT_SEARCH_SLIDE_TYPE_IMAGE_HORIZONTAL = 5;
export const CONSULTANT_SEARCH_PS_SLIDE_DEFAULT_SLIDE_TYPES = [
    CONSULTANT_SEARCH_SLIDE_TYPE_IMAGE_HORIZONTAL,
];
export const isUseSlide = (isAdmin) => isAdmin;
export const getConsultantServiceTabs = (isAdmin, isClient) => {
    const list = [
        { id: 'search', label: 'コンサルタント', unit: '人' },
        { id: 'seminar', label: 'セミナー', unit: '件' },
        { id: 'service', label: '事例', unit: '件' },
    ];
    if (isClient) {
        list.push({ id: 'psSlide', label: 'スライド', unit: '件' });
    }
    if (isUseSlide(isAdmin)) {
        // 一時的に封印
        list.push({ id: 'slide', label: 'Proffit', unit: '件' });
    }
    return list;
};
export const getEnableSearchTab = (tabs, search) => {
    const idList = tabs.map(({ id }) => id);
    return idList.includes(search) ? search : idList[0];
};
export const CONSULTANT_SEARCH_ORDER_CANDIDATES = [
    {
        color: '#00154f',
        id: 'recommend',
        label: 'キーワードHit率が高い',
        value: 'recommend',
    },
    {
        color: '#00154f',
        id: 'experience',
        label: 'コンサル歴順',
        value: 'experience',
    },
    {
        color: '#00154f',
        id: 'newer',
        label: '新着順',
        value: 'newer',
    },
];
export const CONSULTANT_SEARCH_SEMINAR_ORDER_CANDIDATES = [
    {
        color: '#00154f',
        id: 'recommend',
        label: 'キーワードHit率が高い',
        value: 'recommend',
    },
    {
        color: '#00154f',
        id: 'deadline',
        label: '開催日順',
        value: 'deadline',
    },
    {
        color: '#00154f',
        id: 'newer',
        label: '新着順',
        value: 'newer',
    },
];
export const CONSULTANT_SEARCH_SLIDE_ORDER_CANDIDATES = [
    {
        color: '#00154f',
        id: 'desc_text_count',
        label: '文字量多い順',
        value: 'desc_text_count',
    },
    {
        color: '#00154f',
        id: 'asc_text_count',
        label: '文字量少ない順',
        value: 'asc_text_count',
    },
    {
        color: '#00154f',
        id: 'recommend',
        label: 'おすすめ順',
        value: 'recommend',
    },
];
export const CONSULTANT_SEARCH_PS_SLIDE_ORDER_CANDIDATES = [
    {
        color: '#00154f',
        id: 'keyword',
        label: 'キーワードヒット順',
        value: 'keyword',
    },
    {
        color: '#00154f',
        id: 'newer',
        label: '新着順',
        value: 'newer',
    },
];
export const getEnableOrderTab = (order) => {
    const idList = CONSULTANT_SEARCH_ORDER_CANDIDATES.map(({ id }) => id);
    return idList.includes(order) ? order : idList[0];
};
export const getEnableSeminarOrderTab = (order) => {
    const idList = CONSULTANT_SEARCH_SEMINAR_ORDER_CANDIDATES.map(({ id }) => id);
    return idList.includes(order) ? order : idList[0];
};
export const getEnableSlideOrderTab = (order) => {
    const idList = CONSULTANT_SEARCH_SLIDE_ORDER_CANDIDATES.map(({ id }) => id);
    return idList.includes(order) ? order : idList[0];
};
export const getEnablePsSlideOrderTab = (order) => {
    const idList = CONSULTANT_SEARCH_PS_SLIDE_ORDER_CANDIDATES.map(({ id }) => id);
    return idList.includes(order) ? order : idList[0];
};
export const getEnablePage = (page) => {
    const intPage = parseInt(page, 10);
    const fixIntPage = Number.isNaN(intPage) ? 1 : intPage;
    return Math.max(fixIntPage, 1);
};
export const getEnableConsultantSearchIdList = (industries, isNumber = true) => {
    let result = [];
    try {
        const values = Object.values(JSON.parse(industries || '[]'));
        result = isNumber
            ? values.map((v) => parseInt(v, 10)).filter((v) => v > 0)
            : values;
    }
    catch (e) {
        return [];
    }
    return result;
};
export const getEnableConsultantPsSlideTypesList = (industries, slideTypes) => {
    const typesIds = getEnableConsultantSearchIdList(industries);
    const defaultIds = CONSULTANT_SEARCH_PS_SLIDE_DEFAULT_SLIDE_TYPES.map((defaultType) => slideTypes.find(({ dataType }) => dataType === defaultType).id);
    return _.uniq([...typesIds, ...defaultIds]);
};
export const getEnableConsultantSlideSearchType = (searchType) => {
    if (searchType === CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_SLIDE) {
        return CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_SLIDE;
    }
    return CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE;
};
export const CONSULTANT_SEARCH_SLIDE_KINDS_CANDIDATES = [
    {
        id: 1,
        name: 'RFP（Proffitのみ）',
    },
    {
        id: 2,
        name: '提案書（Proffitのみ）',
    },
    {
        id: 3,
        name: 'サービス紹介資料',
    },
];
/**
 * コンサルサーチのデフォルトサジェスト
 * @type {({label: string, value: string})[]}
 */
export const KEYWORD_SUGGESTS = [
    { label: '調査', value: '調査' },
    { label: '新規事業', value: '新規事業' },
    { label: '経営戦略 M&A', value: '経営戦略 M&A' },
    { label: 'マーケティング戦略', value: 'マーケティング戦略' },
    { label: 'ITシステム', value: 'ITシステム' },
    { label: 'コスト削減', value: 'コスト削減' },
];
